var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbsArowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4499 5.43245C11.8088 5.43245 12.0999 5.14143 12.0999 4.78245C12.0999 4.42346 11.8088 4.13245 11.4499 4.13245H2.7538L5.31093 1.57532C5.56477 1.32148 5.56477 0.909918 5.31093 0.656078C5.05709 0.402238 4.64553 0.402238 4.39169 0.656078L0.735932 4.31184C0.611712 4.43023 0.534302 4.5973 0.534302 4.78245C0.534302 4.84415 0.542892 4.90384 0.558962 4.96039C0.560272 4.96502 0.561642 4.96963 0.563052 4.97422C0.593202 5.07232 0.647082 5.16469 0.724702 5.24231L4.39169 8.9093C4.64553 9.1631 5.05709 9.1631 5.31093 8.9093C5.56477 8.6555 5.56477 8.2439 5.31093 7.9901L2.75332 5.43245H11.4499Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbsArowLeft);
export default __webpack_public_path__ + "static/media/breadcrumbs-arow-left.05ad39d2c77b0ce3a89ae81de1314df6.svg";
export { ForwardRef as ReactComponent };